import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';
const OrderIssueSuccess = () => {
  const $ = _c(3);
  const successWrapperRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      successWrapperRef.current?.scrollIntoView({
        block: "center",
        inline: "center"
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-gray" ref={successWrapperRef}><h1 className="mb-6 text-2xl font-bold">We’ve received your request!</h1><p className="mb-6 text-sm">A sincere thank you for taking the time to complete the details of what went wrong, it will help us serve you and ensure we get your issue resolved as quick as possible.</p><p className="mb-6 text-sm">A representative will follow up with you shortly to discuss next steps.</p><CtaLink to="/" block={true} styling="solid-button" color="brand">Back to home page</CtaLink></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default OrderIssueSuccess;